<template>
  <div class="intro">

    <h1>My Web App Project</h1>

    <div class="loading-box">

      <!-- Circle Loading -->
      <div class="circle-loading">
        <i class="xi-spinner-2 xi-spin xi-3x"></i>
      </div>

      <!-- Bar Loading -->
      <div class="bar-loading">

        <!-- count -->
        <div id="count"></div>

        <!-- bar -->
        <div id="bar">
          <div id="progressBar"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Intro",
  mounted(){
    this.barLoading();
  },
  methods: {
   
    // 홈으로 이동함수
    homeMove(){
      setTimeout(() => {
        this.$router.push('/home');
      }, 5000);
    },

    // 프로그래스바 함수
    barLoading(){

      var progressCount = $('#count');
      var progressBar = $('#progressBar');
      var count = 5;       // 5 + 20 = 100
      var progress = 10;   // 10 * 20 = 200
      var Timer = setInterval(() => {
        if(progress == 200 && count == 100){
          clearInterval(Timer);
          this.$router.push('/home');
        }else{
          count += 1;    
          progress += 2;   

          progressCount.text(count + "%")
          progressBar.width(progress + "px");
        }
      }, 40);

    }

  }
}
</script>

<style lang="scss" scoped>

  .intro{
    padding-top: 100px;
    background-color: #3A99D8;

    // Logo
    h1{
      width: 126px;
      height: 126px;
      margin: 0 auto 100px;
      text-indent: -9999px;
      overflow: hidden;
      background: url(../assets/images/logo-big.png) no-repeat 50% 50%;
    }

    // loading-box
    .loading-box{
      width: 200px;
      height: auto;
      margin: auto;
      

      // Circle Loading
      .circle-loading{
        height: 63px;
        margin-bottom: 42px;
        text-align: center;
        font-size: 2.1rem;
      }

      // Bar Loading
      .bar-loading{
        font-size: 2rem;
        text-align: center;
        
        #count{margin-bottom: 21px;}

        #bar{
          width: 100%;
          height: 21px;
          border: 1px solid #ccc;
          border-radius: 10px;

          #progressBar{
            width: 25px;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.5);
            border-radius: 10px;
          }
        }

      }

    }

  }

</style>


// WEBPACK FOOTER //
// src/components/Intro.vue